
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  content: {
    padding: 0,
    overflowX: "hidden",
  },
  multFieldLine: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textField: {
    borderRadius: "12px",
    marginBottom: 24,
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
    },
  },
  background: {
    backgroundColor: theme.palette.background100,
    borderRadius: "12px",
  },
  errorField: {
    backgroundColor: theme.palette.background200,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.feedbackError100,
      },
    },
  },
  tokenField: {
    flex: 1,
    marginBottom: 24,
  },
  tokenIcons: {
    marginLeft: theme.spacing(1),
    flexShrink: 0,
  },
  tokenRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      gap: theme.spacing(1),
    },
  },
  btnFullWidth: {
    width: "100%",
    minHeight: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },
  btnWrapper: {
    width: "100%",
    maxWidth: "164px",
    minHeight: "40px",
    borderRadius: "12px",
    fontWeight: 500,
  },

  buttonsContainer: {
    backgroundColor: theme.palette.background100,
    minHeight: "72px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "24px",
    paddingRight: "24px",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}))

export default useStyles;
